import { createSlice } from "@reduxjs/toolkit";
import { IFiltersData } from "src/@types/filtering";
import { FILTERS_SLICE_NAME } from "./actions";
import { getFiltersValuesReducer } from "./reducers";

export interface IFiltersState {
  isLoading: boolean;
  values: IFiltersData;
}

const initialState: IFiltersState = {
  isLoading: false,
  values: null,
};

export const { reducer: filters } = createSlice({
  name: FILTERS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getFiltersValuesReducer(builder);
  },
});
